import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const GetKarbonSetupTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            KarbonSetupTID: {
                Root: 'karbon-setup'
            }
        }
    });
export const KarbonSetupPage = (param)=>{
    let { integration } = param;
    const { KarbonSetupTID } = useMemo(()=>GetKarbonSetupTID(), []);
    const { api, fetchKarbonItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: KarbonSetupTID.Root(),
        pmName: PracticeManagement.Karbon,
        integration: integration,
        getItems: fetchKarbonItems,
        doDisconnect: api.karbon.disconnect,
        linkServiceTemplate: api.karbon.linkServiceTemplate,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.karbonIntegratedIds()
    });
};
